// Lazy accessor shim — avoids FSD circular dependency (shared cannot import entities).
// The app layer registers real accessors at startup via register* functions.

// Minimal user shape — mirrors AuthUser without importing from entities layer
export interface SessionUser {
  id: string
  name: string
  email: string
  role: string
  tenantId: string | null
  tenantSlug?: string
}

let getToken: () => string | null = () => null
let getUser: () => SessionUser | null = () => null
let getTenantId: () => string | null = () => null
let getLanguageCode: () => string | null = () => null
let syncLogin: (user: SessionUser, token: string) => void = () => {}
let syncLogout: () => void = () => {}

export function registerTokenAccessor(fn: () => string | null): void {
  getToken = fn
}

export function registerAuthSync(
  getUserFn: () => SessionUser | null,
  loginFn: (user: SessionUser, token: string) => void,
  logoutFn: () => void,
): void {
  getUser = getUserFn
  syncLogin = loginFn
  syncLogout = logoutFn
}

export function registerAuthContextAccessors(
  tenantIdFn: () => string | null,
  languageCodeFn: () => string | null,
): void {
  getTenantId = tenantIdFn
  getLanguageCode = languageCodeFn
}

export function getStoredToken(): string | null {
  return getToken()
}

export function getStoredUser(): SessionUser | null {
  return getUser()
}

export function getStoredTenantId(): string | null {
  return getTenantId()
}

export function getStoredLanguageCode(): string | null {
  return getLanguageCode()
}

export function syncAuthLogin(user: SessionUser, token: string): void {
  syncLogin(user, token)
}

export function syncAuthLogout(): void {
  syncLogout()
}
